<template>
  <div class="page plan">
    <TopBanner v-if="show_banner">
    </TopBanner>
    <div class="aloow" v-if="!forbid">
      <CreateLocationModal
          :location="selected_location"
          :name_loc="selected_location_name"
          v-on:close-create-location-modal-success="closeCreateLocationModal(true)"
          ref="create_location_modal"></CreateLocationModal>

      <div class="plan_options text-left" :class="getTopBanner ? 'position_plan_options_plus' : 'position_plan_options'" v-if="!hidenSidebar">
        <div class="inner flex flex-col" v-if="!showDirections">
          <div class="top-controls flex items-center justify-between">
            <div class="flex items-center justify-between gap-10p">
              <div class="icon pointer" @click="hidenSidebar = true">
                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M25 28L19 22L25 16" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <rect x="1" y="1" width="42" height="42" rx="7" stroke="#1FBC2F" stroke-width="2"/>
                </svg>
              </div>
              <div class="title fw-b">
                Plan options
              </div>
            </div>
            <div @click="resetAll" class="pointer btn_danger flex items-center justify-between">
              <div class="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 9L15 15" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                  <path d="M15 9L9 15" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="12" cy="12" r="9" stroke="#F2374D" stroke-width="2"/>
                </svg>
              </div>
              <span>Reset all</span>
            </div>
          </div>
          <div class="destinations py-5">
            <div class="title fw-b">
              Destinations
            </div>
            <div class="actions flex py-5 justify-between items-center gap-10p">
              <div :disabled="points.length > 14" class="add-point white-green w-full flex items-center justify-around gap-10p pointer"
                   :class="{'disabled': points.length > 14}"
                   @click="addPoint()">
                <div class="icon">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 1V16.9996" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round"/>
                    <path d="M17.5 9L1.50038 9" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <span>
                Add drop off
              </span>
              </div>
              <div class="white-green w-full flex items-center justify-around gap-10p"
                   @click="reversePoints">
                <div class="icon">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.5 4L23.5 10L17.5 10" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23.5 10L18.86 5.64C17.7853 4.56471 16.4556 3.7792 14.9952 3.35677C13.5348 2.93434 11.9911 2.88875 10.5083 3.22426C9.02547 3.55976 7.6518 4.26543 6.51547 5.27542C5.37913 6.2854 4.51717 7.56678 4.01 9" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.9092 15.2066C20.2028 17.059 18.9046 18.6264 17.2161 19.6653C15.5275 20.7042 13.5432 21.1565 11.5713 20.952C9.59931 20.7474 7.75007 19.8975 6.31072 18.5341C4.87137 17.1708 3.92245 15.3704 3.61132 13.4124C3.30019 11.4544 3.64427 9.44852 4.59012 7.70616C5.53597 5.9638 7.03066 4.58251 8.84208 3.77678C10.6535 2.97106 12.6803 2.78598 14.6077 3.25031C15.3465 3.4283 16.0549 3.6979 16.7178 4.0496" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
                <span >
                Back to origin
              </span>
              </div>
            </div>
            <div class="input-group plan_item origin flex flex-col fw-b"  v-for="(point, index) in points" :key="index">
              <div class="relative" v-if="index == 0">
                <label>Start Location</label>
                <div class="outer relative">
                  <input autocomplete="off" type="text" class="w-full" :id="'point' + index"  v-model="point.point.address" @input="searchAllPoints(index)">
                  <div class="input_actions flex justify-around items-center">
                    <div class="down pointer w-1/3" @click="points[0].origin_locations_open = !points[0].origin_locations_open">
                      <svg :class="{
                        'rotate-180': points[0].origin_locations_open
                      }" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1L4 4L1 1" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="flag pointer w-1/3" @click="saveLocation(point, 'Origin')">
                      <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V10.3698C9 11.2893 7.86348 11.7214 7.25259 11.0342L5.74741 9.34084C5.34962 8.89332 4.65038 8.89332 4.25259 9.34084L2.74741 11.0342C2.13652 11.7214 1 11.2893 1 10.3698V2Z" stroke="#1FBC2F" stroke-width="2"/>
                      </svg>
                    </div>
                    <div class="delete w-1/3 no_visibility">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L7 7" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                        <path d="M7 1L1 7" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </div>
                  </div>
                  <div class="locations absolute p-2 bordered" v-if="points[0].origin_locations_open">
                    <ul class="flex flex-col" v-for="(location, index) in locations" :key="index">
                      <li class="pointer py-2" @click="selectLocation(location, 0)">
                        <span class='location-name'>{{location.name}}</span> - {{location.address}}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="dropdown_block" v-if="point.showList">
                  <ul class="search-dropdown flex flex-col gap-5 py-5">
                    <li v-for="(option, i) in point.points" :key="i">
                      <a href="javascript:void(0)" @click="updateDropOption(option, index)">
                        {{ option.address }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="relative" v-else>
                <label >{{index}} drop</label>
                <div class="outer relative">
                  <input autocomplete="off" type="text" class="w-full" :id="'point' + index"  v-model="point.point.address" @input="searchAllPoints(index)">
                  <div class="input_actions flex justify-around items-center">
                    <div class="down pointer w-1/3" @click="points[index].origin_locations_open = !points[index].origin_locations_open">
                      <svg
                          :class="{
                              'rotate-180': points[index].origin_locations_open
                          }"
                          width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1L4 4L1 1" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="flag pointer w-1/3" @click="saveLocation(point, index + ' drop')">
                      <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 2C1 1.44772 1.44772 1 2 1H8C8.55228 1 9 1.44772 9 2V10.3698C9 11.2893 7.86348 11.7214 7.25259 11.0342L5.74741 9.34084C5.34962 8.89332 4.65038 8.89332 4.25259 9.34084L2.74741 11.0342C2.13652 11.7214 1 11.2893 1 10.3698V2Z" stroke="#1FBC2F" stroke-width="2"/>
                      </svg>
                    </div>
                    <div class="delete w-1/3" @click="deletePoint(index)">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L7 7" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                        <path d="M7 1L1 7" stroke="#F2374D" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </div>
                  </div>
                  <div class="locations absolute p-2 bordered" v-if="points[index].origin_locations_open">
                    <ul class="flex flex-col" v-for="(location, i) in locations" :key="i">
                      <li class="pointer py-2" @click="selectLocation(location, index)">
                        <span class='location-name'>{{location.name}}</span> - {{location.address}}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="dropdown_block" v-if="point.showList">
                  <ul class="search-dropdown flex flex-col gap-5 py-5">
                    <li v-for="(option, i) in point.points" :key="i">
                      <a href="javascript:void(0)" @click="updateDropOption(option, index)">
                        {{ option.address }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="input-group plan_item time">
              <div class="mb30">
                <div class="flex">
                  <div class="mr-2">
                    <label class="block">
                      Select date
                    </label>
                    <date-range-picker
                        class="select_date_range"
                        :timePicker="true"
                        :timePickerIncrement="10"
                        :minDate="disabledDate"
                        @update="onDatesApply"
                        v-model="pickerDates">
                      <template
                          style="min-width: 350px;"
                      >{{ pickerDates.startDate }} - {{ pickerDates.endDate }}</template>
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="vehicles plan_item">
              <div class=" expand flex items-center justify-between py-4">
                <span>Vehicles</span>
              </div>

              <div class="expanded" v-if="expand.vehicles">
                <div class="actions flex flex-col text-center items-center gap-10p">
                  <div class="white-green w-full flex items-center justify-around pointer"
                       @click="addVehicles"
                  >
                    <div class="flex text-center items-center gap-10p w-5/12">
                      <div class="icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.5 18H2C1.44772 18 1 17.5523 1 17V4C1 3.44772 1.44772 3 2 3H13C13.5523 3 14 3.44772 14 4V18H7.5" stroke="#1FBC2F" stroke-width="2"/>
                          <circle cx="5.5" cy="19.5" r="2.5" stroke="#1FBC2F" stroke-width="2"/>
                          <circle cx="18.5" cy="19.5" r="2.5" stroke="#1FBC2F" stroke-width="2"/>
                          <path d="M20.5 18H22C22.5523 18 23 17.5523 23 17V11.2361C23 11.0808 22.9639 10.9277 22.8944 10.7889L20.2764 5.55279C20.107 5.214 19.7607 5 19.382 5H15C14.4477 5 14 5.44772 14 6V13.6667V18H16.5" stroke="#1FBC2F" stroke-width="2"/>
                          <path d="M23 11H14" stroke="#1FBC2F" stroke-width="2"/>
                        </svg>
                      </div>
                      <span>
                      Add vehicle
                    </span>
                    </div>
                  </div>
                  <div class="w-full flex items-center justify-around gap-10p">
                  <span>
                    I have not saved this vehicle
                  </span>
                  </div>
                </div>
                <div class="sliders flex flex-col">
                  <div class="item flex flex-row w-full"
                       v-for="(item, index) in getVehiclesDimensions"
                       :key="index"
                  >
                    <div class="name w-1/3 flex flex-row">
                      <span>{{ item.name }}&nbsp;</span>
                      <span>(&nbsp;{{item.val}}&nbsp;</span>
                      <span>{{item.dimention}}&nbsp;)</span>
                    </div>
                    <vue-range-slider
                        class="w-2/3 "
                        :min="item.min"
                        :max="item.max"
                        :step="item.step"
                        :process-style="{backgroundColor: '#1fbc2f'}"
                        :tooltip="null"
                        v-model="item.val"></vue-range-slider>
                  </div>
                </div>
              </div>

            </div>
            <div class="route_options plan_item">
              <div class="pointer expand flex items-center justify-between py-4" @click="expand.route_options = ! expand.route_options">
                <span>Route options</span>
                <span :class="{
              'active': expand.route_options
              }">
                <svg data-v-2344f364="" width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-2344f364="" d="M7 1L4 4L1 1" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
              </div>
              <div class="expanded preferences flex flex-col" v-if="expand.route_options">
                <div class="sub_title">
                  Route preference
                </div>
                <div class="list1 list flex w-full justify-between items-center">
                  <div class="input_group flex items-center justify-between w-full gap-10p">
                    <div class="w-1/12 pt-1">
                      <input :checked="expand.route_options" type="radio" class="pointer" id="llcn" value="llcn" v-model="preference">
                    </div>
                    <label class="w-11/12" for="llcn">LLCS(ERN)</label>
                  </div>
                  <div class="input_group flex items-center justify-between w-full gap-10p">
                    <div class="w-1/12 pt-1">
                      <input type="radio" id="motorway" value="motorway" class="pointer" v-model="preference">
                    </div>
                    <label class="w-11/12" for="motorway">Motorway</label>
                  </div>
                </div>
                <h3>Avoid roads</h3>
                <div class="list1 list flex w-full justify-between items-center">
                  <div class="flex items-center justify-between w-full gap-10p">
                    <input class="pointer w-1/12" id="tools" checked="" type="checkbox" v-model="preferences.tolls">
                    <label for="tools" class="w-11/12">Tolls</label>
                  </div>
                  <div class="flex items-center justify-between w-full gap-10p">
                    <input class="pointer w-1/12" id="tunnels" checked="" type="checkbox" v-model="preferences.tunnels">
                    <label for="tunnels" class="w-11/12">Tunnel</label>
                  </div>
                  <div class="flex items-center justify-between w-full gap-10p">
                    <input class="pointer w-1/12" id="motorways" checked="" type="checkbox" v-model="preferences.motorways">
                    <label for="motorways" class="w-11/12">Motorway</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="trailers plan_item">
              <div class=" expand flex items-center justify-between py-4">
                <span>Trailers</span>
              </div>
              <div class="expanded" v-if="expand.trailers">
                <div class="actions flex items-center gap-10p">
                  <div class="white-green pointer w-1/3 m-auto w-full flex items-center justify-around gap-10p"
                       @click="addTrailers()"
                  >
                    <div class="flex text-center items-center gap-10p w-5/12">
                      <div class="icon">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="1.5" y="3" width="22" height="14" rx="1" stroke="#1FBC2F" stroke-width="2"/>
                          <circle cx="6" cy="19.5" r="2.5" stroke="#1FBC2F" stroke-width="2"/>
                          <circle cx="11" cy="19.5" r="2.5" stroke="#1FBC2F" stroke-width="2"/>
                          <path d="M22.5 20H20.5V17" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.5 6V14" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8.5 10L16.5 10" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <span>
                        Add trailer
                      </span>
                    </div>
                  </div>
                </div>
                <div class="sliders flex flex-col">
                  <div class="item flex flex-row w-full items-center justify-between"
                       v-for="(item, index) in getTrailersDimensions"
                       :key="index"
                  >
                    <div class="name w-2/5 flex flex-row">
                      <span>{{ item.name }}&nbsp;</span>
                      <span>(&nbsp;{{item.val}}&nbsp;</span>
                      <span>{{item.dimention}}&nbsp;)</span>
                    </div>
                    <vue-range-slider
                        class="w-3/5 "
                        :tooltip="null"
                        :process-style="{backgroundColor: '#1fbc2f'}"
                        :min="item.min"
                        :max="item.max"
                        :step="item.step"
                        v-model="item.val"></vue-range-slider>
                  </div>
                </div>
              </div>
            </div>
            <div class="drivers py-5 plan_item flex-col flex text-center">
              <div class="white-green py-3 title expand flex items-center justify-around pointer m-auto w-full flex items-center gap-10p" @click="expand.drivers = ! expand.drivers">
                <div class="w-1/3 flex items-center gap-10p">
                  <span>Assign driver</span>
                  <span :class="{
              'active': expand.drivers
              }">
                <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-2344f364="" d="M7 1L4 4L1 1" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
                </div>
              </div>
              <div class="expanded py-5" v-if="expand.drivers">
                <div v-if="!all_drivers.length" class="error pb-3">
                  Ooops! No drivers.
                </div>
                <div v-else class="w-full px-4 pb-4">
                  <CustomSelect
                        :view="'name'"
                        :array="all_drivers"
                        v-on:selected-item-in-custom-select="selectDriverID($event)"/>
                </div>
              </div>
            </div>
            <div class="actions generate w-full flex items-center">
              <button class="green-white w-full text-center flex items-center" @click="getPoints">Generate</button>
            </div>
          </div>
        </div>
        <div class="inner way" v-if="getMultiWaypointsText.length && showDirections">
          <div class="flex-none p-4 border-b">
            <div class="flex justify-between items-center">
              <strong class="text-xl font-medium">
                Directions
              </strong>
            </div>
            <div class="justify-between font-medium">
              <div class="block text-lg text-orange-dark">
                {{ timeDuration }}
                <span class="text-lg text-grey-dark">{{ parsedDistance.m }} miles ({{ parsedDistance.k }} km)</span>
              </div>
              <div class="text-xs pt-1 text-grey-dark">
                Vehicle Dimensions:
                H:{{ getVehiclesDimensions.height.val }}m
                W:{{ getVehiclesDimensions.width.val }}m
                L:{{ getVehiclesDimensions.length.val }}m
                Wt:{{ getVehiclesDimensions.weight.val }}t </div>
            </div>
          </div>
          <div class="actions save flex items-center justify-between gap-10p ">
            <button class="white-green" @click="editRoute()">Edit</button>
            <button class="green-white" @click="open_route_name_popup = true">Save</button>
            <button class="green-white" @click="share()">Save & Share</button>
          </div>
          <ul >
            <li v-for="(item, index) in getMultiWaypointsText" :key="index">
              <ul>
                <li v-for="(el, i) in item" :key="i" class="py-5 bordered_b">

                  <div class="info-block flex" v-if="i == 0">
                    <div class="mark" :style="{backgroundColor: colors[index -1]}"></div>
                    <div class="data px-5 flex flex-col">
                      <div class="flex" v-if="partDistance[index - 1]">
                      <span class="l-title">
                      From:
                      </span>
                        <span>
                      {{partDistance[index - 1].from.address}}
                      </span>
                      </div>
                      <div class="flex" v-if="partDistance[index - 1]">
                      <span class="l-title">
                      To:
                      </span>
                        <span>
                      {{partDistance[index - 1].to.address}}
                      </span>
                      </div>
                      <div v-if="direction_data[index - 1] && direction_data[index - 1].duration">
                        <div class="flex">
                        <span class="l-title">
                        Distance:
                        </span>
                          <span>
                        {{distanceToString(direction_data[index - 1].distance)}}
                        </span>
                        </div>
                        <div class="flex">
                        <span class="l-title">
                        Duration:
                        </span>
                          <span>
                        {{secondsToDhms(direction_data[index - 1].duration)}}
                        </span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="data">
                    <div class="flex items-center gap-15">
                      <div class="icon">
                      <span v-if="el.directions.includes('Turn left')">
                      <img src="@/assets/images/directions-svg/continue_left.svg" alt="logo">
                      </span>
                        <span v-if="el.directions.includes('Turn right')">
                      <img src="@/assets/images/directions-svg/continue_right.svg" alt="logo">
                      </span>
                        <span v-if="el.directions.includes('roundabout')">
                      <img src="@/assets/images/directions-svg/roundabout.svg" alt="logo">
                      </span>
                        <span v-if="el.directions.includes('Continue')">
                      <img src="@/assets/images/directions-svg/continue.svg" alt="logo">
                      </span>
                      </div>
                      <div class="flex gap-10p justify-between items-center">
                        <span>{{el.road}}</span>
                        <span>{{el.directions}}</span>
                      </div>

                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div v-else>
        <div class="icon rotated" @click="hidenSidebar = false">
          <svg transform="rotate(180)" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25 28L19 22L25 16" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <rect x="1" y="1" width="42" height="42" rx="7" stroke="#1FBC2F" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <AltHeader class="alt_header"></AltHeader>
      <l-map
          :zoom="zoom"
          :center="center"
      >
        <span v-if="getLowEmissionPoi.length">
        <l-polygon
            :lat-lngs="getLowEmissionPoi[0]"
            :color="colors[1]"
        >
      </l-polygon>
      </span>
        <span v-if="getUlez.length">
        <l-polygon
            v-for="(points, index) in getUlez"
            :lat-lngs="points"
            :color="colors[1]"
            :key="index"
        >
      </l-polygon>
      </span>
        <span v-if="getLondonControlPolygon.length">
        <l-polygon
            v-for="(points, index) in getLondonControlPolygon"
            :lat-lngs="points"
            :color="colors[3]"
            :key="index"
        >
      </l-polygon>
      </span>


        <l-control-zoom position="topright" v-if="getDropState" ></l-control-zoom>

        <l-tile-layer
            :url="url"
            :attribution="attribution"></l-tile-layer>

        <span v-if="markers.length">

          <span
              v-for="(marker, index) in markers"
              :key="index">

      <l-marker
          v-if="marker.lat && marker.lng"
          :lat-lng="marker"
          :draggable="allowDrug"
          @dragend="updateMarkerPosition(index, $event)"
          :icon="createIconWithText(index + 1)"
      >
      </l-marker>
          </span>



      </span>

        <span v-if="waypoints.length > 1">
        <l-polyline :lat-lngs="waypoints"></l-polyline>
      </span>
        <span v-if="getMultiWaypoints.length">
        <span
            v-for="(points, index) in getMultiWaypoints"
            :key="index"
        >
                  <l-polyline
                      v-if="points.length > 1"
                      :lat-lngs="points"
                      :color="colors[index -1]"

                  ></l-polyline>
        </span>

      </span>

        <span v-if="getLondonControlPolyline.length">
        <span
            v-for="(points, index) in getLondonControlPolyline"
            :key="index"
        >
                  <l-polyline
                      v-if="points.length > 1"
                      :lat-lngs="points"
                      :color="colors[2]"

                  ></l-polyline>
        </span>

      </span>

        <l-control
            v-if="getDropState"
            :position="'topright'"
            class="custom-control"
        >
          <div class="openZone" v-if="!openedControls" @click="openedControls = true">
            <img
                id="openZoneIcon"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjCA0QIRL9HpdLAAAAb0lEQVRIx+2UsQ2AMAwEz5kAKGAOGIKREcoOpIQVkgo2CDOEVxqUc/22/2UZGobRCfoHdrJQmxGZhA2iMbN+lmd8pWgbRRgDi6APcEmXeDqy5CCrFo4qwTYK0R4KeCMxCg2SI0gODgN6ocEtjf8JL8xwTdntrvCyAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA4LTEzVDE0OjMzOjE4KzAyOjAwCfKvqwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wOC0xM1QxNDozMzoxOCswMjowMHivFxcAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC">
          </div>
          <div class="inner control">
            <div class="controls" v-if="openedControls">
              <div class="closeZone px-4 text-left controlZone leaflet-control" @click="openedControls = false">
                <img id="closeZoneIcon"
                     class=" rotate-180"
                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfjCA0PLAnVr8SnAAACzUlEQVRIx7XVz29UVRjG8U8706EQEqUt7WCnthmbBkvEH7hj4YLExLjAGFm5MdE/wkjU2Wnigo1LFyQE/wYjWEtCYkAkBug0DSJtKCj0N7SdtjNzr4veXu6dKa2J8ezOfc/3Oed533PPy/849jmhZdtITsGR3fBuX5rytdamyB7vuOSCN3bCe5U8FJjxhX2pSLuTLluz7KLXn4X3K5kWCoXuO+1AAn/fqIpQYMUFr22HF5VMRngoNOFNbRH+gRGrcWTZmWZ8UMmdBL7mjAEZtDvlopU4suGG97bDbyfwdd8ako3wnxL4uus+lNsJDyw7q6g18j6SwNdc81EjXmzAF50zFBXupNGE94qrPm7E+1PeA/POOxzX/bJKAr/ik0a8N5X5wJzvvRzduhOuWEsc/moz3p2o++buW3jWcb/bSKTuWvPhn1fyMOX9fLz7UeNqicJdb07dXiULicItOxd5z3nFrUSk5kZz4Sgl0hNadzbKfNbRFB4ad6oZb1URJuYtWqJfOFRTtevI+M26Y/bG80E9ymaFFv3suHy89oBhCybU0wI1N1UdsT/60mbAC8pmBZaMektn9Ca06jBoVTkpkcG6CTVDnotM5BQUjJsRmPerYw7KRKs7Ddgw9lRiM7DqD3XF6L9v0a6gNzLyyLhh3bKxRJ+aW1sSmUho2aTAizpSEmNmBR6YUtQdvQlZnQrqWxKZ2Mxj9wQKOmOJfnlj5gTu+VufnoREn+qmkacCLJoW6NUV5+IlXW5aUjNl3iE90T3I6tKvoqyeFGDR/dQpcobtcduSqkmLeuQTEkVLJtICLJhGf/yMZryqRdkTVXc9lpePjGR0OWy6UWDTSFqiww8eCdTd9SQlsd9cswAL/lSP78UD3/nRCqi5Y16vvDahil9886wrfshn/hKY8XlDY8l51yWVnRsLHPSpKV9t09py3jayW2vjPzfXfzn+AehwUE3Q+VlgAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA4LTEzVDEzOjQ0OjA5KzAyOjAw1busIwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wOC0xM1QxMzo0NDowOSswMjowMKTmFJ8AAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC">
              </div>
              <div class="lowEmissionMain controlZone leaflet-control w-full px-4 pt-3">
                <div id="lowEmission" class="flex items-center justify-between gap-5p w-full">
                <span class="w-2/12">
                  <img src="data:image/png;base64,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">
                </span>
                  <span class="w-8/12">Low Emissions</span>
                  <input class="w-2/12" type="checkbox" v-model="low_emission">
                </div>
              </div>
              <div class="ulezMain controlZone leaflet-control w-full px-4">
                <div id="ulez" class="flex items-center justify-between gap-5p w-full">
              <span class="w-2/12">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAEmElEQVR4nO2dT2gcVRzHfzaLWxOSZiU1G1ITEppCixVDRAI5RCQGLypCCkUPLT0JJdCC2INHzcFSUMhFPOkhUKEgeooxihH/BKHmYElLoykbunRrQrc0dHUlIfILnbK782bmzZ/Qb7vfz3H3vd97M595v/fmzbD72NbW1pYQGHZRBRYUAgaFgEEhYFAIGBQCBoWAQSFgUAgYFAIGhYBBIWBQCBgUAgaFgEEhYFAIGBQCBoWAQSFgUAgYFAIGhYBBIWBQCBgUAgaFgEEhYFAIGBQCBoWAQSFgUAgYKb/uLK7OylJxuuqz9qbDMth5zOoo5vOfy827fwTWty0XBlPMKPRlXpFDe0fu1/zq6juxY/odm6+Q8ua6XFs/H7lhPSE29W3L7UTbQXS1DFWVSLqftTBlgUEhYFDIA2B3qtWzUd855FGjp/movH7gXKyjOjVw3apceeOunL/yphTLF13fDWTf8qzHEbJDLNy8YJQx3DkpbY09no1SyA6Qv3NJ5gvvuQLrCO3PvuHbIIUkjKaq2RW3jCca9slL3e8GNkYhCfPDykfGVPVC9ow0p58KbIxCEmS5OC+Xi5+4AtqkKoe6WmXd/m9JFgpf+pZJNzRXbZXYoqnq29wpV2nbVOVQV0I0lczl3emkEl0FRUFT1T+b7iWxbapyYMpKAB11plR1MPO2dapyoJCYrJf/lt8KH7qCaKp6set06OAUUsOedEeo8t/nzhpT1cvdH0s61RS6/bqaQzLpAXm27bhvmb2NvdbxNFWZtuM1VfVmBiP1sa6EtD7eFzqne7FWuiZz+XHXt1FTlQNTVkS+y71vrBg1VTmEFhLmidm/m7dcn9U+gXsY0VR1ozTj6nl/25nIqcoh0gjR4RqErj5MnX7Y0Y1DU6rS+Wmw80Tso/MV8nTLc8bPLxamAgP/kv80VMxaTKMrLknENG0cKiNdE7FSlYOvEN23V/O16E3QN8sfbI+CWnQLYS43abxR0limZwH6FkYtOrqCtjn8MD2VixtT38IxbRwOZieks+WZyHErCfwhZd0w+3p5zPN73ThrTXdLOtUS+KbHaNdnxn2ioDY6Gkdld8OTvgcytO9klWw98abUEiam1LwGpBfawpr7JtA2lkPk14AUnaR0sjJ1RJxJfj24ExrDa9NO29DloukGS+5d2UE8v1F9f7E/MyRzee9KtvNb5SLkdjkXK5YNVpP6cPf49gmNitbVGH7ocjFJdENPU0mSmFJr0livsvSE6k6oXsm2aFmtEyRD7o2S13ovhIofRH/72PZdc5LxkuyfidA/xq+T9uLajKzc+dlzvtCceiDzqhxqGw298tD4fxV/ldXSZSmUFqzTwZG+ac+JVZfpfxZ/3J7jCqWfPFOjCb2gKu/udSHze+ELuVKcChWnEr+3X2L/O4IerJ5ERU++3xsVJBj+XQUY3MsCg0LAoBAwKAQMCgGDQsCgEDAoBAwKAYNCwKAQMCgEDAoBg0LAoBAwKAQMCgGDQsCgEDAoBAwKAYNCwKAQMCgEDAoBg0LAoBAwKAQMCgGDQsCgEDAoBAwKAYNCwKAQMCgECRH5H3dadXYpG3Z+AAAAAElFTkSuQmCC">
              </span>
                  <span class="w-8/12">ULEZ</span>
                  <input class="w-2/12" type="checkbox" v-model="ulez">
                </div>
              </div>

              <div class="llcsMain controlZone leaflet-control w-full px-4">
                <div id="llcs" class="flex items-center justify-between gap-5p w-full">
              <span class="w-2/12">
                <img src="data:image/png;base64,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">
              </span>
                  <span class="w-8/12">London Lorry Control </span>
                  <input class="w-2/12" type="checkbox" v-model="london_control">
                </div></div>
            </div>
          </div>
        </l-control>
      </l-map>
      <div class="flex add_name flex-col py-5 px-5" v-if="open_route_name_popup">
        <div class="top flex justify-between">
          <h2 class="text-left">Save route</h2>
          <span @click="open_route_name_popup = false" class="close pointer">x</span>
        </div>
        <div class="input_group flex flex-col">
          <label class="text-left">Route name</label>
          <input v-model="route_name" type="text">
        </div>
        <div class="actions py-3 flex w-2/3 m-auto gap-15">
          <button class="white-green w-1/2" @click="open_route_name_popup = false">Cancel</button>
          <button class="green-white w-1/2" @click="saveDirections">Save</button>
        </div>
      </div>
      <div class="flex gap-15">
        <div class="add_items add_vehicles" v-if="getAddVehicles"
             :class="{'w-1/3 minified': getAddTrailers, 'w-2/3': !getAddTrailers, }"
        >
          <PopupVehiclesSelect
          />
        </div>
        <div class="add_items add_trailers"
             :class="{'w-1/3 minified r-side': getAddVehicles, 'w-2/3': !getAddVehicles, }"
             v-if="getAddTrailers">
          <PopupTrailersSelect
          />
        </div>
      </div>
    </div>
    <div class="not-allow" v-else>
      <AltHeader class="alt_header"></AltHeader>

      <OutOfLimit
          class="not-allow-banner"
          :items="'routes'"
          :itemsProps="'routes limit'"
          :count="allowedCount"
      />
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LControlZoom, LMarker, LPolyline, LControl, LPolygon } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import AltHeader from "../../components/AltHeader";
import TopBanner from "../../components/TopBanner";
import PopupVehiclesSelect from "../../components/PopupVehiclesSelect";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import {infoMessage} from "../../../../admin/src/services/messages";
import {mapGetters, mapMutations} from "vuex";
import CreateLocationModal from "../../components/CreateLocationModal";
import CustomSelect from "@/components/customel/CustomSelect";
import OutOfLimit from "@/components/OutOfLimit";
import PopupTrailersSelect from "@/components/PopupTrailersSelect";
import {createIconWithText} from "@/services/helpers";
import {searchAddressesDebounced} from "@/services/addressSearch";
import {getUserLocation, getMapZoomForLocation, UK_FALLBACK_CENTER} from "@/services/userLocation";
import {getHereLeafletTileUrl, HERE_LEAFLET_ATTRIBUTION} from "@/utils/hereLeafletTiles";
import { computeEndDateFromDuration } from "@/helpers/planned-route-dates";
L.Icon.Default.imagePath = "https://unpkg.com/leaflet@1.3.4/dist/images/";


export default {
  name: "Plan",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    AltHeader,
    LControlZoom,
    TopBanner,
    DateRangePicker,
    VueRangeSlider,
    LPolyline,
    LControl,
    LPolygon,
    PopupVehiclesSelect,
    CreateLocationModal,
    CustomSelect,
    OutOfLimit,
    PopupTrailersSelect
  },
  data() {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);
    return {
      allowDrug: true,
      forbid: false,
      allowedCount: 0,
      open_route_name_popup: false,
      share_new_route: false,
      show_banner: false,
      route_name: '',
      preference: null,
      preferences: {
        tolls: false,
        tunnels: false,
        motorways: false
      },
      traffic_main: null,
      low_emission: null,
      ulez: null,
      london_control: null,
      traffic_main_poi: null,
      low_emission_poi: null,
      ulez_poi: null,
      london_control_poi: null,
      openedControls: false,
      hidenSidebar: false,
      startPoi: [],
      colors: {
        0: 'blue',
        1: 'red',
        2: 'green',
        3: 'yellow',
        4: 'blue',
        5: 'red',
        6: 'green',
        7: 'yellow',
        8: 'blue',
        9: 'red'
      },
      direction_data: null,
      locations: [],
      origin: {
        address: null,
        position: null
      },
      origin_poi: null,
      last_dropoff: null,
      originSearchRes: null,
      showOriginList: false,
      showDirections: false,
      duration: null,
      timeDuration: null,
      distance: null,
      parsedDistance: {
        k: null,
        m: null
      },
      disabledDate : new Date().toISOString().slice(0, 10),
      expand: {
        trailers: false,
        drivers: false,
        route_options: false,
        vehicles: false,
      },
      pickerDates: {
        startDate,
        endDate
      },
      startDateUserSet: false,
      endDateUserSet: false,
      state :{
        disabledDates : {
          to: new Date(new Date().getTime() - 86400000)
        },
      },
      start_date: '',
      end_date: '',
      points: [{
        label: '',
        point: {
          address: null,
          position: null
        },
        points: null,
        showList: false,
        origin_locations_open: false,
        postcode: null
      },
        {
          label: '',
          point: {
            address: null,
            position: null
          },
          points: null,
          showList: false,
          origin_locations_open: false,
          postcode: null
        }],
      waypoints: [],
      partDistance: [],
      zoom: 6,
      center: { ...UK_FALLBACK_CENTER },
      userAt: null,
      url: getHereLeafletTileUrl(),
      attribution: HERE_LEAFLET_ATTRIBUTION,
      markers: [
        {
          lat: 0,
          lng: 0
        },
        {
          lat: 0,
          lng: 0
        },
      ],
      markerObjects: null,
      route_info: null,
      selected_location: null,
      selected_location_name: null,
      all_drivers: [],
      selected_driver_id: null,
    };
  },

  methods: {
    createIconWithText,

    ...mapMutations([
      'setMultiWaypoints',
      'dropMultiWaypoints',
      'setMultiWaypointsText',
      'setLowEmissionPoi',
      'setUlez',
      'setLondonControlPolygon',
      'setLondonControlPolyline',
      'clearMultiWaypoints',
      'clearMultiWaypointsText',
      'setLoading',
      'setVehiclesDimensions',
      'setAddVehicles',
      'setAddTrailers',
      'setShareNewRouteId'
    ]),
    updateMarkerPosition(i,e) {
      this.markers[i] = L.latLng(e.target._latlng.lat, e.target._latlng.lng);
      this.points[i].point.position = {
        Latitude: e.target._latlng.lat,
        Longitude: e.target._latlng.lng
      }
    },
    share(){
      this.open_route_name_popup = true;
      this.share_new_route = true;
    },
    reversePoints() {
      this.points = [].concat(this.points).reverse();
      this.markers = [].concat(this.markers).reverse();
    },
    editRoute() {
      this.showDirections = false;
      this.allowDrug = true;
      this.duration = null;
      this.timeDuration = null;
      this.distance = null;
      this.parsedDistance.k = null;
      this.parsedDistance.m = null;
    },
    clearMap() {
      console.log(LPolyline);
    },
    resetAll() {
      const startDate = new Date();
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      this.origin.address = null;
      this.clearMultiWaypoints();
      this.clearMultiWaypointsText();
      this.origin.position = null;
      this.origin_poi = null;
      this.last_dropoff = null;
      this.originSearchRes = null;
      this.showOriginList = false;
      this.showDirections = false;
      this.duration = null;
      this.timeDuration = null;
      this.distance = null;
      this.parsedDistance.k  = null;
      this.parsedDistance.m = null;
      this.pickerDates = {startDate,endDate}
      this.startDateUserSet = false;
      this.endDateUserSet = false;
      this.start_date = '';
      this.end_date = '';
      this.points = [{
        label: '',
        point: {
          address: null,
          position: null
        },
        points: null,
        showList: false,
        origin_locations_open: false,
        postcode: null
      },
        {
          label: '',
          point: {
            address: null,
            position: null
          },
          points: null,
          showList: false,
          origin_locations_open: false,
          postcode: null
        }];
      this.waypoints = [];
      this.markers = [];
      this.clearMap();
    },
    onDatesApply(val) {
      if (!val) {
        return;
      }
      this.pickerDates = {
        startDate: new Date(val.startDate),
        endDate: new Date(val.endDate),
      };
      this.startDateUserSet = true;
      this.endDateUserSet = true;
    },
    syncEndDateFromDuration() {
      if (this.endDateUserSet || !this.duration) {
        return;
      }
      const computedEnd = computeEndDateFromDuration(
        this.pickerDates.startDate,
        this.duration,
      );
      if (computedEnd) {
        this.pickerDates.endDate = computedEnd;
      }
    },
    buildV1RouteInfoTimes() {
      this.syncEndDateFromDuration();
      return {
        time_start: this.pickerDates.startDate || new Date(),
        time_end: this.pickerDates.endDate || this.pickerDates.startDate || new Date(),
      };
    },
    selectDriverID(val) {
      this.selected_driver_id = val.id;
    },
    selectLocation(val, index) {
      this.points[index].origin_locations_open = false;
      this.points[index].point.address = val?.name ? val?.name + ', ' + val.address : val.address;
      this.points[index].point.position = {
        Latitude: val.geo.latitude,
        Longitude: val.geo.longitude
      }
      this.points[index].postcode = val.postcode
      if (this.markers[index]) {
        this.markers[index] = L.latLng(this.points[index].point.position.Latitude, this.points[index].point.position.Longitude);
      } else {
        this.markers.push(L.latLng(this.points[index].point.position.Latitude, this.points[index].point.position.Longitude));
      }
    },
    addVehicles() {
      this.setAddVehicles(true);
    },
    addTrailers() {
      this.setAddTrailers(true);
    },
    async saveDirections() {
      this.open_route_name_popup = false;
      this.setLoading(true)
      await this.setRouteInfo();
      if (this.direction_data.length > 1) {
        let j = this;
        this.direction_data.forEach((item, index) => {
          j.direction_data[index][0].from = j.partDistance[index].from || '';
          j.direction_data[index][0].to = j.partDistance[index].to || '';
        })
      } else {
        this.direction_data[0].from = this.partDistance[0].from || '';
        this.direction_data[0].to = this.partDistance[0].to || '';
      }

      const { time_start, time_end } = this.buildV1RouteInfoTimes();
      const request_data = {
        direction_data: this.direction_data,
        driver_id: this.selected_driver_id,
        last_dropoff: this.points[this.points.length - 1].point.address || null,
        origin: this.points[0].point.address || null,
        route_info: this.route_info || null,
        route_name: this.route_name || null,
        time_end,
        time_start,
        useTrailer: false,
        vehicle_group_id: [],
        vehicles: this.getSelectedVehicles || null,
        trailer_info: this.getSelectedTrailers || null,
        v_size: this.calcFinalDimentions(),
        t_params: this.getTrailersDimensions,
        v_params: this.getVehiclesDimensions,
      };

      const response = await this.$http.postAuth(`${this.$http.apiUrl()}/routes/new`, request_data).catch(err => {
        const errors = err.response?.data?.message;
        if (typeof errors === 'string') {
          return infoMessage(errors || 'Oops. Something went wrong...', 'error')
        }
        return this.errorsHandler(errors);
      });
      this.setLoading(false);
      await this.resetAll();
      if (response.status === 201) {
        if (this.share_new_route) {
          this.setShareNewRouteId(response.data.id);
        }
        this.$router.push({name: 'Routes'})
      }
    },
    calcFinalDimentions() {
      let v_size = this.getVehiclesDimensions;
      v_size.width.val = Math.max(this.getVehiclesDimensions.width.val, this.getTrailersDimensions.width.val);
      v_size.height.val = Math.max(this.getVehiclesDimensions.height.val, this.getTrailersDimensions.height.val);
      v_size.length.val = Math.max(this.getVehiclesDimensions.length.val || 0, this.getTrailersDimensions.length.val || 0);
      v_size.weight.val = this.getVehiclesDimensions.weight.val;
      return v_size
    },
    async getPoints() {
      this.setAddVehicles(false);
      this.setAddTrailers(false);
      if (this.points[1].point.position == null || this.points[0].point.position == null) {
        return infoMessage('Please add route drops...', 'error')
      }

      let request_data = {
        pois: this.points,
        dates: this.pickerDates,
        v_size: this.calcFinalDimentions(),
        tolls: this.preferences.tolls,
        tunnels: this.preferences.tunnels,
        motorways: this.preferences.motorways
      }

      this.waypoints = [];
      this.setLoading(true)

      let result = await this.$http.postAuth(`${this.$http.apiUrl()}/subscriptions/directions`, request_data);
      let status = 0;
      let errMsg = null;
      if (result?.data[0]) {
        result.data.forEach(item => {
          if (item[0] && item[0].status && item[0].status != 0) {
            status = item[0].status;
            errMsg = item[0].detail[0].reason;
          }
          if (item.status && item.status != 0) {
            status = item.status;
            errMsg = item.detail[0]?.reason || null;
          }
        })
      }

      if (status > 0) {
        this.setLoading(false)
        return infoMessage(
            errMsg || 'Sorry, no compliant route found',
            'error'
        )
      }

      await this.clearMultiWaypoints()
      await this.clearMultiWaypointsText()
      for await (const item of result?.data) {
        await this.parseCoordinates(item)
      }

      this.timeDurationDistanceParse();
      this.syncEndDateFromDuration();
      this.direction_data = result.data;

      let thObj = this;
      this.points.forEach((item, index) => {
        let firstPart = item.point.address.split(', ');
        let secondPart = null;
        let secondRegion = null;
        let secondPostcode = null;
        let secondFullAddress = null;
        if (index + 1 < thObj.points.length) {
          secondPart = thObj.points[index + 1]?.point?.address?.split(', ') || null;
          secondRegion = secondPart[2] || null;
          secondPostcode = secondPart[0] || null;
          secondFullAddress = thObj.points[index + 1]?.point?.address;
        }
        thObj.partDistance.push({
          from:{
            region: firstPart[2] || null,
            postcode: firstPart[0] || null,
            address: item.point.address,
            admin_district: firstPart[2] || null
          },
          to:{
            region: secondRegion,
            postcode: secondPostcode,
            address: secondFullAddress,
            admin_district: secondRegion || null
          },
        })
      })

      this.setLoading(false)
      this.allowDrug = false;
    },
    async setRouteInfo() {
      const address = this.points[0].point.address.split(', ');

      let otherPoints = []
      this.points.forEach((point, index) => {
        if (index === 0) {
          return;
        }
        otherPoints.push(point.point.address)
      })
      this.route_info = {
        ...this.buildV1RouteInfoTimes(),
        locations: [
          {
            geo: {
              region: address[1] || null,
              postcode: address[0] || null,
              admin_district: address[2] || null,
            },
            lat: this.points[0].point.position.Latitude,
            lon: this.points[0].point.position.Longitude
          }
        ],
        distance: this.partDistance,
      }

      let rInfo = this.route_info;

      await this.points.forEach((item, index) => {
        if (index === 0 ) {
          return;
        }
        let poiAddress = item.point.address.split(', ')
        rInfo.locations.push({
          geo: {
            region:  poiAddress[1] || null,
            postcode: poiAddress[0] || null,
            admin_district: poiAddress[2] || null
          },
          lat: item.point.position.Latitude,
          lon: item.point.position.Longitude
        })
      })
    },
    async setRePlanData() {
      const replan_route_id = this.$route.query.replan_route_id;
      if (!replan_route_id) {
        return;
      }

      try {
        const response = await this.$http.getAuth(
          `${this.$http.apiUrl()}/routes/${replan_route_id}`,
        );
        const route = response?.data;
        if (!route) {
          return;
        }

        if (route.route_version === 'v2') {
          return this.$router.push({
            name: 'HereRePlan',
            query: { replan_route_id },
          });
        }

        const locations = route.route_info?.locations || [];
        if (locations.length >= 2) {
          this.points = locations.map((location) => {
            const addressParts = [
              location.geo?.postcode,
              location.geo?.region,
              location.geo?.admin_district,
            ].filter(Boolean);

            return {
              label: '',
              point: {
                address: addressParts.join(', ') || route.origin || '',
                position: {
                  Latitude: location.lat,
                  Longitude: location.lon,
                },
              },
              points: null,
              showList: false,
              origin_locations_open: false,
              postcode: location.geo?.postcode || null,
            };
          });
          this.markers = locations.map((location) =>
            L.latLng(location.lat, location.lon),
          );
        }

        if (route.route_info?.time_start && route.route_info?.time_end) {
          this.pickerDates = {
            startDate: new Date(route.route_info.time_start),
            endDate: new Date(route.route_info.time_end),
          };
          this.startDateUserSet = true;
          this.endDateUserSet = true;
        }

        this.route_name = route.name || '';
        this.partDistance = route.route_info?.distance || [];
        this.direction_data = route.direction_data;
        this.duration = 0;
        this.distance = 0;

        await this.clearMultiWaypoints();
        await this.clearMultiWaypointsText();

        for await (const item of route.direction_data || []) {
          await this.parseCoordinates(item);
        }

        this.timeDurationDistanceParse();
        this.showDirections = true;
        this.allowDrug = true;
      } catch (e) {
        console.log(e);
      }
    },
    timeDurationDistanceParse() {
      this.timeDuration = this.secondsToDhms(this.duration);
      this.parseDistance();
    },
    parseDistance() {
      this.parsedDistance.k = Math.round(this.distance / 1000);
      this.parsedDistance.m = Math.round((this.distance / 1000) / 1.609344);
    },
    distanceToString(meters) {
      if(meters)
        return `${Math.round(meters / 1000)} Km (${Math.round((meters / 1000) / 1.609344)} miles)`;
      else return ''
    },
    secondsToDhms(seconds) {
      seconds = Number(seconds);
      var d = Math.floor(seconds / (3600*24));
      var h = Math.floor(seconds % (3600*24) / 3600);
      var m = Math.floor(seconds % 3600 / 60);

      var dDisplay = d > 0 ? d + (" d, ") : "";
      var hDisplay = h > 0 ? h + (" h, ") : "";
      var mDisplay = m > 0 ? m + ("min") : "";
      return dDisplay + hDisplay + mDisplay;
    },
    async parseCoordinates(item){
      let point = item;
      if (item[0])
      {
        point = item[0]
      }
      let coordinates = [];
      for await (let coordinate of point.geojson.coordinates) {
        if (coordinate[1] && coordinate[0]) {
          coordinates.push((L.latLng(coordinate[1], coordinate[0])))
        }
      }
      if(coordinates?.length > 0) {
        await this.setMultiWaypoints(coordinates)
        await this.setMultiWaypointsText(point.detail)
      }
      this.showDirections = true;
      this.duration = this.duration + point.duration
      this.distance = this.distance + point.distance
    },
    updateDropOption(option, index) {
      this.points[index].point.address = option.address;
      this.points[index].point.position = option.position;
      this.points[index].showList = false;
      this.points[index].postcode = option.address.split(', ')[0];
      if (this.markers[index]) {
        this.markers[index] = L.latLng(option.position.Latitude, option.position.Longitude);
        return;
      }
      this.markers.push(L.latLng(option.position.Latitude, option.position.Longitude));
    },
    async searchAllPoints(index) {
      let dropOff = await this.searchPoints(this.points[index]?.point?.address, index) || null;
      this.points[index].points = dropOff;
      // this.points[index].showList = true
      if (this.points[index].points) {
        this.points[index].showList = true;
      } else {
        this.points[index].showList = false;
      }
    },
    async searchPoints(searchReq, index) {
      const user = await JSON.parse(localStorage.getItem('user'));
      try {
        return await searchAddressesDebounced(
          this.$http,
          searchReq,
          user?.id,
          `plan-point-${index}`,
          this.userAt,
        );
      } catch (err) {
        const errors = err.response?.data?.message;
        if (typeof errors === 'string') {
          return infoMessage(errors || 'Oops. Something went wrong...', 'error')
        }
        return this.errorsHandler(errors);
      }
    },
    addPoint() {
      if (this.points.length > 14) {
        return;
      }
      this.points.push({
        label: '',
        point: {
          address: null,
          position: null
        },
        points: null,
        showList: false,
        origin_locations_open: false,
        postcode: null
      });
    },
    deletePoint(index) {
      if(this.points.length <= 1) {
        return
      }
      this.markers.splice(index, 1);
      this.points.splice(index, 1);
    },
    clickOutsideHandler() {
      document.addEventListener('click', this.clickHandler);
    },
    clickHandler(event) {
      const { target } = event;
      const { $el } = this;

      if (!$el.contains(target)) {
        this.showList = false;
        this.points.forEach(item => {
          item.showList = false;
        })
      }
    },
    async getCustomLayers(prop) {
      try {
        this.setLoading(true);
        const response = await this.$http.getAuth(`${this.$http.apiUrl()}/points-of-interests?prop=${prop}`) || null;
        let emissionCoordinates = [];
        let ulezCoordinates1 = [];
        let ulezCoordinates2 = [];
        let ulezCoordinates3 = [];
        let londonControlPolygonCoordinates = [];
        let londonControlPolylineCoordinates = [];
        let j = this;
        switch (prop) {
            // case 'traffic_main': return this.getPoints('') ; break;
          case 'low_emission':
            this.low_emission_poi = response.data;
            this.low_emission_poi.features[0].geometry.coordinates[0].forEach(poi => {
              emissionCoordinates.push([poi[1], poi[0]]);
            })
            this.setLowEmissionPoi(emissionCoordinates)
            break;
          case 'ulez':
            this.ulez_poi = response.data;
            this.ulez_poi.features[0].geometry.coordinates[0].forEach(poi => {
              ulezCoordinates1.push([poi[1], poi[0]]);
            })
            this.ulez_poi.features[1].geometry.coordinates[0].forEach(poi => {
              ulezCoordinates2.push([poi[1], poi[0]]);
            })
            this.ulez_poi.features[2].geometry.coordinates[0].forEach(poi => {
              ulezCoordinates3.push([poi[1], poi[0]]);
            })
            this.setUlez(ulezCoordinates1);
            this.setUlez(ulezCoordinates2);
            this.setUlez(ulezCoordinates3);
            break;
          case 'london_control':
            this.london_control_poi = response.data;
            this.london_control_poi[0].features[0].geometry.coordinates[0][0].forEach(poi => {
              londonControlPolygonCoordinates.push([poi[1], poi[0]]);
            });
            this.london_control_poi[1].features.forEach(item => {
              item.geometry.coordinates.forEach((points) => {
                londonControlPolylineCoordinates = []
                points.forEach(poi => {
                  londonControlPolylineCoordinates.push([poi[1], poi[0]]);
                })

                j.setLondonControlPolyline(londonControlPolylineCoordinates);
              })
            });

            this.setLondonControlPolygon(londonControlPolygonCoordinates);
            break;
        }
        await this.setLoading(false);
        this.zoom = 10;
      } catch (e) {
        console.log(e)
      }
    },
    saveLocation(val, name) {
      if (!val.point.position) {
        infoMessage(
            'Oops. Something went wrong...','error'
        );
      }
      if (val.point && val.point.address) {
        this.selected_location = val.point;
        this.selected_location_name = name;

        this.$refs.create_location_modal.show = true;
      }
    },
    closeCreateLocationModal(val) {
      if (val) {
        infoMessage(
            `Location created`,
            this.getTopBanner ? 'success open_top_banner' : 'success'
        );
      } else {
        infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      }
    },
    async getAllDrivers() {
      const isForbid = await this.$http.getAuth(`${this.$http.apiUrl()}/routes/forbid`);
      if (isForbid?.data?.forbid) {
        this.forbid = true;
        this.allowedCount = isForbid.data.count
      }
      const res_drivers = await this.$http.getAuth(`${this.$http.apiUrl()}/drivers/all`).catch(err => {
        console.error(err);
        this.all_drivers = [];
        return infoMessage(
            'Oops. Something went wrong...',
            this.getTopBanner ? 'error open_top_banner' :'error'
        );
      });

      this.all_drivers = res_drivers?.data?.drivers || [];
    },
    async getLocations() {
      try {
        const requestData = {
          skip: 0,
          take: 999,
          sort: 'name',
          column: 'name',
          search: '',
          ascending: false,
        }
        const response = await this.$http
            .getAuth(`${this.$http.apiUrl()}/locations?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`);

        this.locations = response?.data?.locations?.data || [];
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {

    "markers" : {
      async handler(val) {
        console.log(val)
      },
      deep: true
    },

    traffic_main(val) {
      if (val) {
        this.getCustomLayers('traffic_main')
      }
    },
    low_emission(val) {
      if (val) {
        this.getCustomLayers('low_emission')
      } else {
        this.setLowEmissionPoi(false);
      }
    },
    ulez(val) {
      if (val) {
        this.getCustomLayers('ulez')
      } else {
        this.setUlez(false);
      }
    },
    london_control(val) {
      if (val) {
        this.getCustomLayers('london_control')
      } else {
        this.setLondonControlPolygon(false);
        this.setLondonControlPolyline(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      'getMultiWaypoints',
      'getMultiWaypointsText',
      'getLowEmissionPoi',
      'getUlez',
      'getLondonControlPolygon',
      'getLondonControlPolyline',
      'getVehiclesDimensions',
      'getTrailersDimensions',
      'getSelectedVehicles',
      'getSelectedTrailers',
      'getTopBanner',
      'getDropState',
      'getAddVehicles',
      'getAddTrailers'
    ]),
  },
  async mounted() {
    const location = await getUserLocation();
    this.userAt = { lat: location.lat, lng: location.lng };
    this.center = { lat: location.lat, lng: location.lng };
    this.zoom = getMapZoomForLocation(location);

    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.api_version === 'v2' && !this.$route.query.replan_route_id) {
      return this.$router.push({name: 'HerePlan'})
    }
    L.Icon.Default.imagePath = "https://unpkg.com/leaflet@1.3.4/dist/images/";
    this.clickOutsideHandler();
    this.getAllDrivers();
    this.getLocations();
    VueRangeSlider.methods.handleKeyup = ()=> console.log;
    VueRangeSlider.methods.handleKeydown = ()=> console.log;
    this.expand.trailers = true;
    this.expand.vehicles = true;
    await this.setRePlanData();
  },
};
</script>

<style lang="scss" scoped>
.vue2leaflet-map {
  height: 877px;
}
.location-name {
  font-weight: bold;
  font-size: 14px;
  color: #292929;
}
.add_items {
  position: absolute;
  top: 180px;
  left: 400px;
  min-height: 150px;
  z-index: 400;
  background-color: #fff;
  border-radius: 5px;
  &.r-side{
    left: calc(35% + 400px);
  }
}
.not-allow-banner {
  padding-top: 150px;
  margin-bottom: 200px;
}
.page {
  position: relative;
  .white-green {
    cursor: pointer;
  }
  .drivers {
    .white-green {
      padding: 12px;
    }
    .expanded {
      overflow: visible;
    }
  }
  .inner {
    &.way {
      max-height: 650px;
      max-width: 350px;
      min-width: 320px;
      overflow-y: auto;
    }
  }
  .vue-range-slider.slider-component {
    .slider {
      .slider-dot {
        background-color: #1fbc2f !important;
      }
    }
  }
  .vehicles {
    .actions {
      .white-green {
        text-align: center;
        margin: auto;
      }
    }
  }
  .vue-range-slider {
    width: 100%!important;
  }
  .alt_header {
    position: absolute;
    height: 50px;
    z-index: 401;
  }
  .outer {
    position: relative;
    .input_actions {
      position: absolute;
      right: 0;
      top: 10px;
      width: 60px;
    }
  }
  .plan_options {
    min-width: 355px;
    position: absolute;
    left: 15px;
    z-index: 401;
    border-radius: 6px;
    background-color: #ffffff;
    .actions {
      .white-green {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 44px;
      }
    }
    &>.inner {
      padding: 15px;
      max-height: 600px;
      overflow: scroll;
    }
  }
  .position_plan_options {
    top: 90px;
  }
  .position_plan_options_plus {
    top: 90px;
  }
}
.btn_danger {
  padding: 7px 10px;
}
.input-group {
  input {
    border: 1px solid #D0D5DA;
    box-sizing: border-box;
    border-radius: 18px;
  }
}
.plan_item {
  .expand {
    padding-right: 10px;
    .active {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .mb30 {
    .flex {
      width: 100%;
      .mr-2 {
        margin: 0;
        width: 100%;
      }
      .vue-daterange-picker {
        width: 100%;
      }
    }
  }
}
.actions {
  &.save {
    padding-top: 15px;
    button {
      min-width: 80px;
    }
  }
}
.preferences {
  input[type="radio"] {
    max-width: 20px;
    &:checked {
      &:checked {
        background: #FFA800 !important;
        border: #FFA800 !important;
      }
      &:before, &:after {
        background: #FFA800 !important;
        border: #FFA800 !important;
      }
    }
  }
}
.vue-daterange-picker ::v-deep .reportrange-text{
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 18px !important;
  width: 100%;
}
.data {
  padding-bottom: 20px;
  .icon {
    width: 20px;
  }
}
.icon {
  &.rotated {
    width: 44px;
    height: 44px;
    background: #fff;
    border-radius: 8px;
    left: 15px;
    position: absolute;
    top: 150px;
    z-index: 999;
  }
}
.add_name {
  position: absolute;
  max-width: 400px;
  left: 0;
  right: 0;
  top: 300px;
  margin: auto;
  z-index: 401;
  background: #fff;
}
.closeZone {
  transform: rotate(180deg);
  float: left;
}
.openZone {
  background: #fff;
  padding: 5px 5px;
  border-radius: 4px;
  width: 34px;
  border: 2px solid rgba(0,0,0,.2);
  background-clip: padding-box;
}
.custom-control {
  .controls {
    width: 230px;
    height: 150px;
    padding-left: 15px;
    background-color: #fff;
    img {
      max-width: 20px;
    }
  }
}
.no_visibility {
  opacity: 0;
}
.dropdown_block {
  width: 100%;
  padding: 0 10px;
  z-index: 405;
  background: #ffffff;
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 5px;
  position: absolute;
  top: 54px;
  left: 0;
}
.title {
  font-size: 14px;
}
.locations{
  &.absolute {
    background-color: #fff;
    width: 100%;
    z-index: 100;
  }
}
.down {
  .rotate {

  }
}
</style>
